import styled from "styled-components";

const LI = styled.li`
  color: var(--neutral-700, #404040);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  list-style-type: disc;
`;

const SB = styled.span`
  font-weight: 700;
`;

export const ReportMessage = ({ type }: any) => {
  switch (type) {
    case "식단":
      return (
        <>
          <LI>
            식단 루틴은 <SB>총 7회</SB> 기록되었습니다.
          </LI>
          <LI>
            기록된 식사 중 <SB>60% 이상이 탄수화물 위주</SB>의 구성으로
            나타났습니다.
          </LI>
          <LI>
            특히, 점심 식사에서 <SB>채소와 단백질이 포함되지 않은 경우</SB>가
            자주 확인됩니다.
          </LI>
          <LI>
            전체 식단의 <SB>영양 균형이 다소 불균형</SB>한 양상이 보입니다.
          </LI>
        </>
      );
    case "걷기":
      return (
        <>
          <LI>
            3,000걸음 이상 기록된 날은 <SB>5일</SB>로 나타났습니다.
          </LI>
          <LI>
            기록된 걸음 중 평균 3,500보 이상이 달성된 날은 <SB>주중 4일</SB>로
            나타났습니다.
          </LI>
          <LI>
            특히, <SB>주말에는 평균 2,000보</SB>로 평일 대비 낮은 활동량을
            보였습니다.
          </LI>
          <LI>
            전체 걸음수의 활동량 분포가 고르지 않아{" "}
            <SB>주말 활동 증가가 권장</SB>
            됩니다.
          </LI>
        </>
      );
    case "복약":
      return (
        <>
          <LI>
            복약 루틴은 <SB>총 6회 기록</SB>
            되었습니다.
          </LI>
          <LI>
            설정된 복용 시간 <SB>08:00 기준 ±30분 이내 복용</SB> 기록은 5회로
            매우 양호합니다.
          </LI>
          <LI>
            특히, 평일 복약 기록이 매일 빠짐없이 이루어져{" "}
            <SB>규칙적인 습관이 형성</SB>되었습니다.
          </LI>
          <LI>
            전체 복약의 시간 준수도가 높아 <SB>우수한 관리 상태</SB>입니다.
          </LI>
        </>
      );
    default:
      return null;
  }
};

export const AIMessage = ({ type }: any) => {
  switch (type) {
    case "식단":
      return (
        <>
          <LI>혈당 · 체중 관리에 불리한 식단 패턴이에요</LI>
          <LI>
            점심/저녁에 <SB>채소와 단백질을 추가</SB>
            해보세요
          </LI>
        </>
      );
    case "걷기":
      return (
        <>
          <LI>주말에도 규칙적인 산책 시간을 가져보세요</LI>
          <LI>
            평일 활동량이 우수하니 <SB>이를 꾸준히 유지</SB>해주세요
          </LI>
        </>
      );
    case "복약":
      return (
        <>
          <LI>현재 복약 습관이 매우 우수합니다</LI>
          <LI>
            <SB>알림 기능을 활용</SB>해 지금처럼 꾸준히 유지해주세요
          </LI>
        </>
      );
    default:
      return null;
  }
};
